// Takes a Base64 number, decoded it, add the new items, and return a new Base64 number
export const getNewEndCursor = (previousCursor, newItemsCount) => {
  return btoa(parseInt(atob(previousCursor)) + newItemsCount)
}
